import React, { FC } from 'react'
import styles from 'styles/components/calendar.module.scss'
import getDate from 'date-fns/getDate'
import isSameDay from 'date-fns/isSameDay'
import isSameMonth from 'date-fns/isSameMonth'
import { useDispatch, useSelector } from 'react-redux'
import { State } from 'index'
import { getCurrentDate } from 'reducks/calendar/selectors'
import { handleCurrentDate } from 'reducks/calendar/operations'

type Props = {
  date: Date
  isActive: boolean
  isClosed: boolean
  isOrdered: boolean
  isSpecialHoliday: boolean
}

const MonthlyCalendarCell: FC<Props> = React.memo((props) => {
  const { date, isActive, isClosed, isOrdered, isSpecialHoliday } = props

  const dispatch = useDispatch()
  const currentDate = useSelector((state: State) => getCurrentDate(state))
  const isThisMonth = isSameMonth(date, currentDate)

  const className = (() => {
    switch (true) {
      // 休業日・臨時休業日が祝日
      case isThisMonth && isClosed && isSpecialHoliday:
        return styles.table__cell__holiday_disabled
      // 休業日・臨時休業日
      case isThisMonth && isClosed:
        return styles.table__cell_disabled
      // 選択状態
      case isThisMonth && isActive && !isClosed:
        return styles.table__cell_active
      // 当日が祝日
      case isThisMonth && isSameDay(date, new Date()) && isSpecialHoliday:
        return styles.table__cell__holiday_today
      // 当日
      case isThisMonth && isSameDay(date, new Date()):
        return styles.table__cell_today
      case isThisMonth && isSpecialHoliday:
        return styles.table__cell__holiday
      default:
        return styles.table__cell
    }
  })()

  return (
    <td className={className} onClick={() => (isClosed || !isThisMonth ? null : dispatch(handleCurrentDate(date)))}>
      <span className={styles.table__cell__date}>
        {isThisMonth ? getDate(date) : ''}
        {isThisMonth && isActive && isOrdered && <span className={styles.table__mark_white} />}
        {isThisMonth && !isActive && isOrdered && <span className={styles.table__mark} />}
      </span>
    </td>
  )
})

export default MonthlyCalendarCell
